import airKnight from "./air-knight.jsx";
import waterKnight from "./water-knight.jsx";
import fireKnight from "./fire-knight.jsx";
import earthKnight from "./earth-knight.jsx";
import darkness from "./darkness.jsx";

export default {
  darkness: darkness,
  "air-knight": airKnight,
  "water-knight": waterKnight,
  "fire-knight": fireKnight,
  "earth-knight": earthKnight,
};
